/**
 * Basic linear regression
 * Taken from https://github.com/Tom-Alexander/regression-js
 */

export type Predictor = {
  predict: (x: number) => [number, number];
  equation: [number, number];
};

export function linear(data: Array<[number, number]>): Predictor {
  const sum = [0, 0, 0, 0, 0];
  let len = 0;

  for (let n = 0; n < data.length; n++) {
    if (data[n][1] !== null) {
      len++;
      sum[0] += data[n][0];
      sum[1] += data[n][1];
      sum[2] += data[n][0] * data[n][0];
      sum[3] += data[n][0] * data[n][1];
      sum[4] += data[n][1] * data[n][1];
    }
  }

  const run = len * sum[2] - sum[0] * sum[0];
  const rise = len * sum[3] - sum[0] * sum[1];
  const gradient = run === 0 ? 0 : rise / run;
  const intercept = len === 0 ? 0 : sum[1] / len - (gradient * sum[0]) / len;

  const predict = (x: number): [number, number] => [x, gradient * x + intercept];

  return {
    predict,
    equation: [gradient, intercept]
  };
}
